const HEADER_HEIGHT = 60;

export { HEADER_HEIGHT };
